module.exports = __webpack_public_path__ + "img/swiperTwo.f3a47352.png";